import store from '@/state/store'

export default [
  {
    path: '/',
    name: 'home',
    meta: {
      authRequired: false,
    },
    beforeEnter(to, from, next) {
      try {
        const stored = JSON.parse(localStorage.getItem('medicino_counter') || 'null')
        if (stored && Number(stored.token_management_type) === 3) {
          return next({ name: 'outsource-tokens' })
        }
      } catch (e) { /* ignore */ }
      next()
    },
    component: () => import('./views/token/index.vue'),
  },

  {
    path: '/token/index',
    name: 'tokens',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/token/index.vue'),
  },

  {
    path: '/token/outsource',
    name: 'outsource-tokens',
    meta: {
      authRequired: false,
    },
    component: () => import('./views/token/outsource.vue'),
  },

  {
    path: '/login',
    name: 'login',
    component: () => import('./views/account/login'),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({ name: 'default' })
        } else {
          // Continue to the login page
          next()
        }
      },
    },
  },
  
  {
    path: '/logout',
    name: 'logout',
    meta: {
      authRequired: true,
      beforeResolve(routeTo, routeFrom, next) {
        if (process.env.VUE_APP_DEFAULT_AUTH === "firebase") {
          store.dispatch('auth/logOut')
        } else {
          store.dispatch('authfack/logout')
        }
        const authRequiredOnPreviousRoute = routeFrom.matched.some(
          (route) => route.push('/login')
        )
        // Navigate back to previous page, or home as a fallback
        next(authRequiredOnPreviousRoute ? { name: 'default' } : { ...routeFrom })
      },
    },
  },
  {
    path: '/404',
    name: '404',
    component: require('./views/utility/404').default,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: '*',
    redirect: '404',
  },

 
  
]
